import { QueryOrderSettings, QueryPaginationSettings, TableFilterField } from '@sprinx/query-builder';
import { DefaultValue, atom, selector } from 'recoil';
import { MoleculerListResult } from '../../@sprinx/knihovka-types';
import { ApiClient } from '../../@sprinx/react-after-razzle';
import {
  ListCallParams,
  buildListQuery,
  createListInitialSettings,
} from '../../@sprinx/react-after-razzle/filteredLists';
import { GlobalStateRegister } from '../../@sprinx/react-after-razzle/stateStore';
import { apiClientState, localeState } from '../appState';

export interface CustomerDocument {
  // hrefs: {
  //   // href: string;
  //   type: string;
  // }[];
  // orderNo: string;

  extra: {
    createDate: Date;
  };
  id: string;
  number: string;
}

export const documentsQuery = selector<MoleculerListResult<CustomerDocument>>({
  key: 'documents',
  get: ({ get }) => {
    const initialState = get(documentsInitialState);
    if (initialState) {
      return initialState;
    }

    const apiClient = get(apiClientState);
    const locale = get(localeState);
    const params = get(documentsCallParamsState);
    get(documentsReloadTrigger);

    return getdocuments(apiClient, locale, params);
  },
  set: ({ set }, newValue) => {
    if (newValue instanceof DefaultValue) {
      set(documentsReloadTrigger, (n) => n + 1);
    }
  },
});

export const documentsCallParamsState = GlobalStateRegister.register(
  atom<ListCallParams>({
    key: 'documentsCallParams',
    default: createListInitialSettings({
      rowsPerPage: 10,
      orderBy: 'extra.createDate',
      orderDirection: 'desc',
    }),
  }),
);

export const documentsOrderByState = selector<QueryOrderSettings>({
  key: 'documentsOrderBy',
  get: ({ get }) => {
    const params = get(documentsCallParamsState);
    return params.order;
  },
  set: ({ set }, newValue) => {
    if (!(newValue instanceof DefaultValue)) {
      set(documentsCallParamsState, (prev) => ({
        ...prev,
        order: newValue,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }));
    }
  },
});

export const documentsPaginationState = selector<QueryPaginationSettings & { total: number }>({
  key: 'documentsPagination',
  get: ({ get }): QueryPaginationSettings & { total: number } => {
    const params = get(documentsCallParamsState);
    const queryResult = get(documentsQuery);

    return {
      page: queryResult.page || params.pagination.rowsPerPage,
      rowsPerPage: queryResult.pageSize || params.pagination.rowsPerPage,
      total: queryResult.total,
    };
  },
  set: ({ set }, newValue) => {
    if (!(newValue instanceof DefaultValue)) {
      set(documentsCallParamsState, (prev) => ({
        ...prev,
        pagination: {
          // ...prevValue.pagination,
          ...newValue,
        },
      }));
    }
  },
});

export const documentsFilterState = selector<TableFilterField<any>[]>({
  key: 'documentsFilter',
  get: ({ get }) => {
    const params = get(documentsCallParamsState);
    return (params.filter as TableFilterField<any>[]) || [];
  },
  set: ({ set }, newValue) => {
    if (!(newValue instanceof DefaultValue)) {
      const nextFilter = newValue.filter(Boolean);

      set(documentsCallParamsState, (prev) => ({
        ...prev,
        filter: nextFilter,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }));
    }
  },
});

export const documentsInitialState = GlobalStateRegister.register(
  atom<MoleculerListResult<CustomerDocument> | undefined>({
    key: 'documentsInitialState',
    default: undefined, // createListDefaultResult<documentsProduct>(),
  }),
);

export function getdocuments(
  apiClient: ApiClient,
  locale: string,
  params: ListCallParams,
): Promise<MoleculerListResult<CustomerDocument>> {
  return apiClient.get<MoleculerListResult<CustomerDocument>, Record<string, any>>(
    '/v1/documents',
    buildListQuery(params, { type: 'document', fields: ['id', 'number', 'extra.createDate'] }),
  );
}

export const documentsReloadTrigger = atom<number>({
  key: 'documentsReloadTrigger',
  default: 0,
});
